import styled from "styled-components";

export const PlainList = styled.ul`
    list-style: none;
    font-size: 1rem;
    word-break: break-word;
`;
